import { render, staticRenderFns } from "./ScrollArea.vue?vue&type=template&id=a10b62a0&"
import script from "./ScrollArea.vue?vue&type=script&lang=ts&"
export * from "./ScrollArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports